<template>
  <div class="partner-card-skeleton">
    <div class="skeleton-layout">
      <div class="skeleton-logo-wrap">
        <div class="skeleton-logo"></div>
      </div>
      <div class="skeleton-content">
        <div class="skeleton-name"></div>
        <div class="skeleton-info">
          <div class="skeleton-line"></div>
          <div class="skeleton-line skeleton-line--mid"></div>
          <div class="skeleton-line skeleton-line--short"></div>
        </div>
        <div class="skeleton-footer">
          <div class="skeleton-button"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PartnerCardSkeleton"
};
</script>

<style scoped>
.partner-card-skeleton {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: none;
  padding: 24px;
  overflow: visible;
}

.skeleton-layout {
  display: flex;
  gap: 24px;
  align-items: flex-start;
}

.skeleton-logo-wrap {
  flex-shrink: 0;
  width: 200px;
}

.skeleton-content {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}

@keyframes shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

.skeleton-logo,
.skeleton-name,
.skeleton-line,
.skeleton-button {
  background: linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.skeleton-logo {
  width: 100%;
  height: 100px;
  border-radius: 12px;
}

.skeleton-name {
  height: 17px;
  width: 45%;
  border-radius: 4px;
  margin-bottom: 8px;
}

.skeleton-info {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.skeleton-line {
  height: 14px;
  width: 100%;
  border-radius: 4px;
}

.skeleton-line--mid {
  width: 85%;
}

.skeleton-line--short {
  width: 60%;
}

.skeleton-footer {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #f1f5f9;
}

.skeleton-button {
  height: 44px;
  width: 130px;
  border-radius: 10px;
}

/* Tablet */
@media (max-width: 768px) {
  .partner-card-skeleton {
    padding: 16px;
  }

  .skeleton-layout {
    flex-direction: column;
    gap: 0;
  }

  .skeleton-logo-wrap {
    width: 100%;
    margin-bottom: 16px;
  }

  .skeleton-logo {
    height: 80px;
  }

  .skeleton-content {
    width: 100%;
  }

  .skeleton-name {
    height: 16px;
    width: 50%;
  }

  .skeleton-line {
    height: 14px;
  }

  .skeleton-line--short {
    display: none;
  }
}

/* Mobile */
@media (max-width: 480px) {
  .skeleton-logo {
    height: 70px;
    border-radius: 10px;
  }

  .skeleton-logo-wrap {
    margin-bottom: 12px;
  }

  .skeleton-name {
    height: 16px;
    margin-bottom: 4px;
  }

  .skeleton-line {
    height: 14px;
  }

  .skeleton-footer {
    margin-top: 12px;
    padding-top: 12px;
  }

  .skeleton-button {
    width: 100%;
    height: 48px;
  }
}

@media (max-width: 639px) {
  .partner-card-skeleton {
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
    padding: 12px;
    border-radius: 12px;
    overflow: hidden;
  }

  .skeleton-layout {
    gap: 12px;
  }

  .skeleton-logo {
    min-height: 88px;
    height: 88px;
    border-radius: 10px;
  }

  .skeleton-button {
    min-height: 48px;
    height: 48px;
  }
}
</style>
